module.exports = __webpack_public_path__ + "static/assets/7fb362a0dd68b91fcb4eb0642ddbcd4a.svg";